import React, { useState, useEffect, useRef } from 'react'
import { useStyles } from './styles'

const STATUS = {
  START: 'START',
  STOP: 'STOP',
}

interface CountdownProps {
  triggersOnZero: () => void,
  initialCount: number
}

export function Countdown({ triggersOnZero, initialCount }: CountdownProps) {
  const styles = useStyles();
  const [seconds, setSeconds] = useState(initialCount);
  const [status, setStatus] = useState(STATUS.START);

  const secondsToDisplay = seconds % 60;
  const minutes = (seconds - secondsToDisplay) / 60;
  const minutesToDisplay = minutes % 60;

  const twoDigits = (num: number) => String(num).padStart(2, '0');

  const handleStop = () => {
    setStatus(STATUS.STOP);
    triggersOnZero();
  }

  function useInterval(callback: () => void, delay: number | null) {
    const savedCallback = useRef(callback);

    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  useInterval(
    () => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        handleStop();
      }
    },
    status === STATUS.START ? 1000 : null
  );

  return (
    <div className={styles.Timer}>
      <div>
        {twoDigits(minutesToDisplay)}:{twoDigits(secondsToDisplay)}
      </div>
    </div>
  )
}
